module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (67).4d78907e.jpg";